// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectPlan_container__Eq8Mj","infoBox":"SelectPlan_infoBox__xsf5f"};